import { Link } from 'react-router-dom';
import { rankedComics } from '@/mocks/comics';

export default function RankingSection() {
  return (
    <section className="py-14 md:py-20 bg-accent-50">
      <div className="w-full px-4 md:px-6">
        <div className="mb-10">
          <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-medium rounded-full">
            排行榜
          </span>
          <h2 className="mt-3 text-2xl md:text-3xl font-heading text-foreground-950">
            韩漫人气 <span className="text-accent-600">TOP 10</span>
          </h2>
          <p className="mt-2 text-sm text-foreground-500">根据阅读量排名的热门韩漫，看看大家都在追什么</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {rankedComics.slice(0, 5).map((comic, index) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group flex items-center gap-4 p-4 rounded-lg bg-background-50 hover:bg-background-100 transition-colors duration-200 cursor-pointer"
              data-product-shop
            >
              <span className={`text-2xl md:text-3xl font-bold font-heading ${
                index === 0 ? 'text-primary-500' :
                index === 1 ? 'text-accent-500' :
                index === 2 ? 'text-secondary-500' :
                'text-foreground-400'
              }`}>
                {String(index + 1).padStart(2, '0')}
              </span>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-900 truncate group-hover:text-primary-500 transition-colors duration-200">
                  {comic.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-0.5">{comic.author}</p>
                <div className="flex items-center gap-2 mt-1">
                  <span className="text-xs text-primary-500 flex items-center gap-0.5">
                    <i className="ri-star-fill text-[10px]"></i>
                    {comic.rating}
                  </span>
                  <span className="text-xs text-foreground-400">{comic.views}阅读</span>
                </div>
              </div>
              <div className="w-14 h-14 flex-shrink-0 rounded-lg overflow-hidden">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}